/**
 * Como a resposta da IA é quebrada em mensagens de WhatsApp.
 *
 * A decisão real acontece no backend, em
 * `supabase/functions/_shared/split-assistant-message.ts`. Aqui só existem o
 * valor persistido e os rótulos da tela.
 *
 * Não há "máximo de blocos" configurável de propósito: a quantidade é
 * consequência da semântica do texto. Um teto fixo era justamente o que fazia a
 * versão antiga descartar o final das respostas longas.
 */

export type MessageSplitStyle = 'multi' | 'single'

export const DEFAULT_MESSAGE_SPLIT_STYLE: MessageSplitStyle = 'multi'

export const MESSAGE_SPLIT_STYLE_OPTIONS: ReadonlyArray<{
  value: MessageSplitStyle
  labelKey: string
}> = [
  { value: 'multi', labelKey: 'configure.splitStyleMulti' },
  { value: 'single', labelKey: 'configure.splitStyleSingle' },
]

export function isMessageSplitStyle(value: unknown): value is MessageSplitStyle {
  return value === 'multi' || value === 'single'
}
